export default {
    // "user list": 'getUserList',
    // "user": 'getUser',
    "auth history": 'getAuthHistory',
    "balancer history": 'getBalancerHistory',
    "full user history": 'getFullHistory',
    "session history": 'getSessionHistory'
}



// WEBPACK FOOTER //
// ./src/script/logsParameters.js